// extracted by mini-css-extract-plugin
module.exports = {"questionBox":"QuestionTypeBox_questionBox__1vJgt","questionBoxText":"QuestionTypeBox_questionBoxText__2vad2 base-styles_whiteBox__EFz-f"};